module.exports = {
      id: "close-usage",
      viewBox: "0 0 512.001 512.001",
      url: __webpack_public_path__ + "svg-sprite.svg#close",
      toString: function () {
        return this.url;
      }
    }